module.exports = __webpack_public_path__ + "img/Metastasis-PDAC_GSE202740.240cb9eb.png";